import React from "react";
import { Link } from "react-router-dom";
import { HERO_IMAGES, BRANCH_LIST, LOGOS } from "@/lib/brand";

export default function About() {
  return (
    <div data-testid="page-about">
      <section className="relative pt-40 pb-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: `url(${HERO_IMAGES.about})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/70 via-[#0a0a0a]/80 to-[#0a0a0a]" />

        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">À propos du groupe</div>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl font-bold tracking-tighter max-w-4xl">
            Un groupe pensé comme un partenaire complet.
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <p className="text-lg leading-relaxed text-zinc-300">
            Le Groupe Equinoxe rassemble trois pôles d'expertise qui partagent une même
            philosophie : l'exigence du détail, le sens du service et la fiabilité.
          </p>
          <p className="mt-6 text-zinc-400 leading-relaxed">
            Que vous soyez chef d'entreprise, responsable d'établissement, organisateur d'événement
            ou particulier, nous mobilisons les bonnes compétences au bon moment, à travers
            <span className="text-violet-400"> Equinoxe Studio</span>,
            <span className="text-orange-500"> Equinoxe Sécurité</span> et
            <span className="text-sky-400"> Equinoxe Propreté</span>.
          </p>
          <p className="mt-6 text-zinc-400 leading-relaxed">
            Chaque pôle conserve son identité, ses équipes et son savoir-faire, mais bénéficie
            d'une coordination centrale pour vous offrir des solutions transverses, simples à
            piloter et toujours alignées sur vos objectifs.
          </p>
        </div>

        <aside className="lg:col-span-5">
          <div className="rounded-xl border border-white/10 bg-[#0e0e0e] p-8">
            <img src={LOGOS.groupe} alt="Equinoxe Groupe" className="h-20 w-20 object-contain mb-6" />
            <h3 className="font-display text-2xl font-semibold mb-4">Notre mission</h3>
            <p className="text-zinc-400 text-sm leading-relaxed">
              Simplifier la vie de nos clients en réunissant sous une seule bannière les
              compétences habituellement éparpillées entre plusieurs prestataires.
            </p>
            <div className="mt-8 grid grid-cols-3 gap-4 text-center">
              {[
                { v: "3", l: "Pôles" },
                { v: "1", l: "Interlocuteur" },
                { v: "∞", l: "Solutions" },
              ].map((s) => (
                <div key={s.l}>
                  <div className="font-display text-3xl font-bold">{s.v}</div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </section>

      <section className="border-t border-white/10 bg-[#070707] py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">Découvrir nos pôles</div>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-12">
            Trois identités, une même rigueur.
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {BRANCH_LIST.map((b) => (
              <Link
                key={b.key}
                to={`/${b.key}`}
                data-testid={`about-branch-${b.key}`}
                className={`group rounded-xl border ${b.accentBorder} bg-[#0e0e0e] p-6 hover-lift`}
              >
                <div className="rounded-lg overflow-hidden bg-white shadow-md shadow-black/20 ring-1 ring-white/10 inline-block mb-5">
                  <img
                    src={LOGOS[b.key]}
                    alt={b.name}
                    className="h-20 w-20 object-contain p-1"
                    style={{ transform: `scale(${b.logoScale || 1})`, transformOrigin: "center" }}
                  />
                </div>
                <h3 className="font-display text-xl font-semibold">{b.name}</h3>
                <p className={`text-sm mt-1 ${b.accentText}`}>{b.tagline}</p>
                <p className="text-sm text-zinc-500 mt-3 line-clamp-3">{b.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
